export default __webpack_public_path__ + "static/media/resultados_prueba2.ac4db46e.pdf";